import { SVGProps } from 'react';

const BoxScaleMediumKindArrow = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M4 8H20V16.2C20 17.8802 20 18.7202 19.673 19.362C19.3854 19.9265 18.9265 20.3854 18.362 20.673C17.7202 21 17.6802 21 16 21M20 7.9966C20.164 7.99236 20.2831 7.98287 20.3902 7.96157C21.1836 7.80376 21.8038 7.18356 21.9616 6.39018C22 6.19698 22 5.96466 22 5.5C22 5.03534 22 4.80302 21.9616 4.60982C21.8038 3.81644 21.1836 3.19624 20.3902 3.03843C20.197 3 19.9647 3 19.5 3H4.5C4.03535 3 3.80302 3 3.60982 3.03843C2.81644 3.19624 2.19624 3.81644 2.03843 4.60982C2 4.80302 2 5.03534 2 5.5C2 5.96466 2 6.19698 2.03843 6.39018C2.19624 7.18356 2.81644 7.80376 3.60982 7.96157C3.7169 7.98287 3.83599 7.99236 4 7.9966M3 14.25H8.625C10.489 14.25 12 15.761 12 17.625C12 19.489 10.489 21 8.625 21H3M3 14.25L5.25 12M3 14.25L5.25 16.5"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default BoxScaleMediumKindArrow;
